// extracted by mini-css-extract-plugin
module.exports = {"spinWrapper":"styles_spinWrapper__3BQdZ","planboardWrapper":"styles_planboardWrapper__1R_SU"};